import { $ } from '../vendors/jquery';

class Accordion
{
    constructor( element ) 
    {
        this.element = element;
        this.buttons = this.element.find( '[data-element="accordion-button"]' );
        this.firstItemInactive = true === this.element.data('firstItemInactive');

        this.init();
    }

    init() 
    {
        if (!this.firstItemInactive) {
            this.setFirstItemActive();
        }
        this.buttons.each( ( index, element ) => {
            $( element ).on( 'click', this.onButtonClick.bind( this, element ) );
        } );
    }

    onButtonClick( element ) 
    {
        const item = this.getItem( element );
        this.toggleItemActive( item );
    }

    getItem( item ) 
    {
        const button = $( item );
        const panel = button.closest( '[data-element="accordion-panel"]' );

        return { button, panel };
    }

    setFirstItemActive() 
    {
        const item = this.getItem( this.buttons[0] );
        this.toggleItemActive( item );
    }

    toggleItemActive( item ) 
    {
        if ( item.panel.hasClass( 'is-active' ) ) {
            item.panel.removeClass( 'is-active' );
            item.button.attr( 'aria-expanded', false );
        } else {
            item.panel.addClass( 'is-active' );
            item.button.attr( 'aria-expanded', true );
        }
    }
}

const accordion = {
    init() {
        const accordionElements = $( '[data-module="accordion"]' );

        if ( null !== accordionElements && accordionElements.length > 0 ) {
            accordionElements.each( ( index, element ) => {
                new Accordion( $( element ) );
            } );
        }
    }
};

export default accordion;
